<template>
  <div class="box full">
    <div class="box-header">
      {{ $t("message.products_sold_together.title") }}
    </div>
    <div class="box-content-block pt-4">
      <template v-if="!loading">
        <button
          class="mt-2 mb-4 btn btn-dark-button mr-4"
          v-if="!showForm"
          @click="recalculateRelation"
        >
          {{ $t("message.products_sold_together.recalculate") }}
        </button>
        <button
          class="mt-2 mb-4 btn btn-info-button"
          v-if="!showForm"
          @click="showForm = true"
        >
          {{ $t("message.products_sold_together.new") }}
        </button>
        <div
          v-else
          class="flex flex-row flex-wrap w-full p-4 mb-4 border border-gray-400 rounded-md"
        >
          <input
            type="text"
            :value="code"
            disabled
            class="regular bordered mr-4"
          />
          <input
            type="text"
            v-model="newCode"
            class="regular bordered mr-4"
            :placeholder="$t('message.products_sold_together.nkr_code_related')"
          />
          <button
            class="btn btn-success-button"
            v-if="newCode != ''"
            @click="addNewCode"
          >
            {{ $t("message.products_sold_together.add") }}
          </button>
        </div>
        <table v-if="products.length > 0">
          <thead>
            <th>{{ $t("message.products_sold_together.image") }}</th>
            <th>{{ $t("message.products_sold_together.title") }}</th>
            <th>{{ $t("message.products_sold_together.ranking") }}</th>
            <th>{{ $t("message.products_sold_together.action") }}</th>
          </thead>
          <ProductsSoldTogetherItem
            v-for="product in products"
            @deletedProduct="deletedItem(product.skuRelated)"
            @updated="loadProducts()"
            :key="product.skuRelated"
            :baseCode="code"
            :product="product"
          />
        </table>
        <div v-else class="text-lg text-center w-full py-10">
          {{ $t("message.products_sold_together.no_relation") }}
        </div>
      </template>
      <template v-else>
        <BaseLoading :loading="true"></BaseLoading>
      </template>
    </div>
  </div>
</template>
<script>
import {
  getProductsSoldTogether,
  createSoldTogether,
  recalculateProductsSoldTogether
} from "@/api/store/ProductsService.js";
import ProductsSoldTogetherItem from "./ProductsSoldTogetherItem.vue";
export default {
  name: "ProductsSoldTogether",
  components: {
    ProductsSoldTogetherItem
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      products: [],
      showForm: false,
      newCode: "",
      loading: true
    };
  },
  computed: {
    userCanEditProducts() {
      return this.$store.getters["auth/userHasPermission"]("can_edit_products");
    }
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    recalculateRelation() {
      this.loading = true;
      recalculateProductsSoldTogether(this.code)
        .then(() => {
          this.$toast.open({
            message: `Relation Recalculated`,
            type: "success",
            position: "top-right"
          });
          this.loadProducts();
        })
        .catch(() => {
          this.$toast.open({
            message: `Error calculating relation`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deletedItem(sku) {
      this.products = this.products.filter(
        product => product.skuRelated != sku
      );
    },
    loadProducts() {
      this.loading = true;
      getProductsSoldTogether(this.code).then(res => {
        this.products = res;
        this.loading = false;
      });
    },
    addNewCode() {
      this.loading = true;
      createSoldTogether(this.code, this.newCode)
        .then(() => {
          this.$toast.open({
            message: `Product Added`,
            type: "success",
            position: "top-right"
          });
          this.loadProducts();
        })
        .catch(() => {
          this.$toast.open({
            message: `Product not added`,
            type: "error",
            position: "top-right"
          });
          this.loading = false;
        });
    }
  }
};
</script>
